import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { UserFeedbackService, ConfigService } from 'app/services';
import { MenuPermissionConfig, ServiceTypeEnum } from 'app/models';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'user-feedback',
    templateUrl: './user-feedback.component.html',
    styleUrls: ['./user-feedback.component.scss',
        '../../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class UserFeedbackComponent implements OnInit, OnChanges {
    @Input() serviceTypeId!: ServiceTypeEnum;

    @Input()
    public menuPermissionActive: string = MenuPermissionConfig.COMMS_FEEDBACKS;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public userFeedbacks: Array<any> = [];

    public selectedCustomer: any = undefined;
    public infoPopupCustomer: any = undefined;

    public cols: any[] = [
        { field: 'Id', header: 'Complaint ID', width: '90px', active: false, isLink: true },
        { field: 'XpressOrderId', header: 'Ride ID', width: '200px', active: false },
        { field: 'DriverFullName', header: 'Driver Name', width: '200px', active: false },
        { field: 'XpressUserId', header: 'Passenger ID', width: '200px', active: false },
        { field: 'CreatedAt', header: 'Complaint Time', width: '200px', active: false },
        { field: 'VehicleTypeText', header: 'Type', width: '200px', active: false },
        { field: 'StatusText', header: 'Status', width: '200px', active: false }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    public tableName: string = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
        riderId: number | null;
        startDate: Date | null;
        endDate: Date | null;
    } = { searchName: '', riderId: null, startDate: null, endDate: null };

    public loading: boolean = true;

    private searchTimer: number = 0;

    public visibleFeedbackFilter: boolean = false;
    public visibleFeedbackDetail: boolean = false;

    public feedbackId: number = 0;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_comms' }, { label: 'Comms' }, { label: 'Feedbacks' }];

    constructor(
        private messageService: MessageService,
        private userFeedbackService: UserFeedbackService,
        public configService: ConfigService
    ) { }

    ngOnInit(): void { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'serviceTypeId') {
                const chng = changes[propName];
                const cur = JSON.stringify(chng.currentValue);
                const prev = JSON.stringify(chng.previousValue);

                if (cur !== prev) {
                    this.getUserFeedbacks(0);
                }
            }
        }
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getUserFeedbacks(skip);
    }

    public getUserFeedbacks(skip: number): void {
        this.loading = true;

        const dto = {
            ServiceTypeId: this.serviceTypeId,
            SearchName: this.filter.searchName,
            RiderId: this.filter.riderId,
            StartDate: this.filter.startDate,
            EndDate: this.filter.endDate,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.userFeedbackService.getUserFeedbacks(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.userFeedbacks = data.Items;

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getUserFeedbacks(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleFilterClear(): void {
        this.filter.searchName = '';

        this.handleFilterChange();
    }

    public openFeedbackFilter() {
        this.visibleFeedbackFilter = !this.visibleFeedbackFilter;
    }

    public openFeedbackDetail(feedbackId: number) {
        this.feedbackId = feedbackId;
        this.visibleFeedbackDetail = !this.visibleFeedbackDetail;
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }
}
